import React from "react";
import { Container, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import DefaultCounterCard from "./DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          {/* 특허권 */}
          <Grid item xs={4} sm={4} md={4}>
            <DefaultCounterCard
              count={6}
              title="특허권"
              description={`
                기술 특허출원 등록 1건<br />
                기술 특허출원 진행중 4건<br />
                디자인 특허출원 등록 1건
              `}
            />
          </Grid>
          {/* 기술임치 */}
          <Grid item xs={4} sm={4} md={4}>
            <DefaultCounterCard
              count={2}
              title="기술임치"
              description={`
                2KV 서지보호 LED 컨버터 및 DC제어<br />
                LED디밍 컨트롤 회로 1건<br />
                AC 채터링 및 잔광제거 부하 보호 스위치 회로 1건
              `}
            />
          </Grid>
          {/* 인증서 */}
          <Grid item xs={4} sm={4} md={4}>
            <DefaultCounterCard
              count={26}
              title="인증서"
              description="KC인증서를 통해 제품의 안전성, 품질, 성능 등을 검증받아 제품의 신뢰성 확보"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
